<template>
  <div class="comp_ry">
    <div class="page-heading" style="background-image: url('static/menhu/images/pp4.jpg')">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1>公司荣誉</h1>
            <span>只有坚实每一步，才能更好更专业</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 荣誉列表 -->
    <div class="gtDiv">
      <div class="simple-recent-projects projects-page full-screen-projects filter-projects section-gap">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12">
              <div class="row masonry-layout filters-content normal-col-gap">
                <div  v-for="(item,index) in ryList" :key="index" class="col-lg-3 masonry-item all category-building">
                  <div class="item">
                    <div class="project-item">
                      <div class="thumb">
                        <el-image
                          :ref="'imageRef'+index"
                          style="width: 100%;height: 240px;max-height: 240px"
                          :src="$fileDPath+item.img"
                          fit="contain"
                          :preview-src-list="[$fileDPath+item.img]"></el-image>
                        <div class="hover">
                          <div class="inner-content"  @click="doImageClick('imageRef'+index)">
                            <h4><a style="cursor: pointer">{{ item.name }}</a></h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'comp_ry',
  data() {
    return {
      ryList:[]
    }
  },
  created() {
    this.getData();
  },
  methods:{
    getData(){
      let _this = this;
      this.$axios.get('/fantis/compry/ftCmsCompRy/list?pageNo=1&pageSize=999')
        .then(function(res){ // 请求成功 HTTP状态码是200
          if(res.data.code == 200){
            var tempData = res.data.result;

            _this.ryList = tempData.records;
          }else{
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    // 点击图片
    doImageClick(ele){
      const imageElement = this.$refs[ele];
      imageElement[0].$el.__vue__.showViewer = true;
      console.dir(imageElement[0].$el.__vue__.showViewer);
    }
  }
}
</script>

<style scoped>
.gtDiv {
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  padding: 0px 20px 0px 20px;
}

.thumb{
  /* box-shadow: 1px 1px 12px gray; */
  padding: 10px;
  border-radius: 14px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}
</style>



// WEBPACK FOOTER //
// src/components/views/comp/comp_ry.vue